.group {
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	gap: var(--lp-spacing-200);
	margin-bottom: var(--lp-spacing-300);

	&[data-orientation='horizontal'] {
		flex-direction: row;
		align-items: center;
		gap: var(--lp-spacing-300);
	}
}
